import { parseRFC5646Tag } from './locale';

export function browserLanguage() {
  return parseRFC5646Tag(navigator.language);
}

export async function copyToClipboard(text) {
  if (!text) {
    return false;
  }

  try {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {
    return false;
  }

  return false;
}
